import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Import Font Awesome
const script = document.createElement('script');
script.src = 'https://kit.fontawesome.com/your-kit-code.js';
script.crossOrigin = 'anonymous';
document.head.appendChild(script);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
